import DeleteIcon from '@mui/icons-material/Delete';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { IconButton, Theme, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormikProps } from 'formik';
import { FormikTextField } from '../../../common/formik-material-ui/FormikTextField';

import clsx from 'clsx';

const useStyles = makeStyles((theme: Theme) => ({
  field: {
    marginTop: theme.spacing(1), // space between fields
    marginBottom: theme.spacing(1), // space between fields
  },
  add: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    marginLeft: theme.spacing(1), // space between fields
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  deleteIconButton: {
    color: theme.custom.button.delete.main,
    height: 'max-content',
    alignSelf: 'center',
  },
  cadenceStyles: {
    '@media (min-width: 1450px)': {
      width: '760px',
    },
    '@media only screen and (min-width: 1385px) and (max-width: 1449px)': {
      width: '700px',
    },
    '@media only screen and (min-width: 1220px) and (max-width: 1384px)': {
      width: '500px',
    },
  },
}));

interface HeaderProps {
  formik: FormikProps<any>;
  cadenceStyles?: boolean;
  formikHeadersPath?: string;
}

export default function Headers(props: HeaderProps) {
  let formikProperty: undefined | { name: string; value: string }[];
  formikProperty = undefined;
  if (props.formikHeadersPath) {
    const paths = props.formikHeadersPath.split('.');
    formikProperty = props.formik.values;
    for (let i = 0; i < paths.length; i++) {
      formikProperty = formikProperty?.[paths[i]];
    }

    if (!formikProperty) {
      formikProperty = [{ name: '', value: '' }];
    }
  }

  const headers: { name: string; value: string }[] = props.formikHeadersPath
    ? formikProperty
    : props.formik.values.headers;

  const classes = useStyles();
  return (
    <>
      {headers.map((header, index) => (
        <div className="row" key={index}>
          <div className="col-11">
            <div
              className={clsx(
                'row',
                props.cadenceStyles && classes.cadenceStyles
              )}
            >
              <div className="col">
                <FormikTextField
                  name={
                    props.formikHeadersPath
                      ? `${props.formikHeadersPath}.${index}.name`
                      : `headers.${index}.name`
                  }
                  className={clsx(classes.field)}
                  formik={props.formik}
                  fullWidth
                  label="Header Name"
                  inputProps={{ maxLength: 150 }}
                  size="small"
                  variant="outlined"
                />
              </div>
              <div className="col">
                <FormikTextField
                  name={
                    props.formikHeadersPath
                      ? `${props.formikHeadersPath}.${index}.value`
                      : `headers.${index}.value`
                  }
                  className={clsx(classes.field)}
                  formik={props.formik}
                  fullWidth
                  label="Header Value"
                  size="small"
                  variant="outlined"
                />
              </div>
            </div>
          </div>
          <div className="col-1">
            <div className="row" style={{ flexWrap: 'nowrap' }}>
              <Tooltip title="add">
                <>
                  <IconButton
                    aria-label="add"
                    color="primary"
                    onClick={() => {
                      props.formik.setFieldValue(
                        props.formikHeadersPath ?? 'headers',
                        [
                          ...headers.slice(0, index + 1),
                          {
                            name: '',
                            value: '',
                          },
                          ...headers.slice(index + 1),
                        ]
                      );
                    }}
                    disabled={headers.length === 10}
                    size="large"
                  >
                    <PlaylistAddIcon />
                  </IconButton>
                </>
              </Tooltip>
              <Tooltip key={index} title="remove">
                <>
                  <IconButton
                    className={classes.deleteIconButton}
                    aria-label="cancel"
                    onClick={() => {
                      props.formik.setFieldValue(
                        props.formikHeadersPath ?? 'headers',
                        [
                          ...headers.slice(0, index),
                          ...headers.slice(index + 1),
                        ]
                      );
                    }}
                    disabled={headers.length <= 1}
                    size="large"
                  >
                    <DeleteIcon />
                  </IconButton>
                </>
              </Tooltip>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
